import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

// project imports
import NavMotion from "./../layout/NavMotion";
import Loadable from "../ui-component/Loadable";
import GuestGuard from "utils/route-guard/GuestGuard";

// login routing
const AuthLogin = Loadable(
  lazy(() => import("../views/pages/authentication/authentication3/Login3")),
);
const AuthHDRegister = Loadable(
  lazy(() => import("../views/pages/pricing/HDRegister")),
);
const AuthHDSubscriptionSuccess = Loadable(
  lazy(() => import("../views/pages/pricing/HDSubscriptionSuccess")),
);
const AuthHDSubscriptionError = Loadable(
  lazy(() => import("../views/pages/pricing/HDSubscribeError")),
);
const AuthHDPricingTab = Loadable(
  lazy(() => import("../views/pages/pricing/HDPriceTabPage")),
);
const AuthHDPricingCard = Loadable(
  lazy(() => import("../views/pages/pricing/HDPriceCard")),
);
const AuthHDSetPassword = Loadable(
  lazy(() => import("../views/pages/pricing/HDSetPwdNew")),
);
const AuthHDSetPasswordSuccess = Loadable(
  lazy(() => import("../views/pages/pricing/HDSetPwdSuccess")),
);

//-----------------------|| AUTH ROUTING ||-----------------------//

const LoginRoutes = {
  path: "/",
  element: (
    <GuestGuard>
      <NavMotion>
        <Routes>
          <Route path="/login" element={<AuthLogin />} />
          <Route path="/pricing-back" element={<AuthHDPricingTab />} />
          <Route path="/pricing" element={<AuthHDPricingCard />} />
          <Route path="/new-register" element={<AuthHDRegister />} />
          <Route
            path="/subscription-successful"
            element={<AuthHDSubscriptionSuccess />}
          />
          <Route path="/signup-error" element={<AuthHDSubscriptionError />} />
          <Route
            path="/set_password/:userUId"
            element={<AuthHDSetPassword />}
          />
          <Route
            path="/password_set_success/:userUId"
            element={<AuthHDSetPasswordSuccess />}
          />
        </Routes>
      </NavMotion>
    </GuestGuard>
  ),
  children: [
    {
      path: "login",
      element: <AuthLogin />,
    },
    {
      path: "new-register",
      element: <AuthHDRegister />,
    },
    {
      path: "subscription-successful",
      element: <AuthHDSubscriptionSuccess />,
    },
    {
      path: "signup-error",
      element: <AuthHDSubscriptionError />,
    },
    {
      path: "pricing-back",
      element: <AuthHDPricingTab />,
    },
    {
      path: "pricing",
      element: <AuthHDPricingCard />,
    },
    {
      path: "set_password/:userUId",
      element: <AuthHDSetPassword />,
    },
    {
      path: "password_set_success/:userUId",
      element: <AuthHDSetPasswordSuccess />,
    },
  ],
};

export default LoginRoutes;
